<template>
  <DModal :show-close="false" :isBgOverlay="true" @close="$emit('close')" :appendToBody="true"
          style="z-index: 12312312312312" :placeInTop="true">
    <div class="d-modal d-modal--width text-dark" id="d-create-task-for-user" slot="insertComponent">
      <div class="d-modal__header">
        <h2>Vælg jeres lønsystem</h2>
      </div>
      <div class="d-modal__content">
        <div class="loader-container" v-if="isLoading">
          <Loader bgColor="#f6f9fc"></Loader>
        </div>
        <div class="d-boxes" v-else>
          <div class="d-box-select"
               v-for="system in systems"
               @click="select(system)">
            {{ system.name }}
          </div>
        </div>
      </div>
    </div>
  </DModal>
</template>
<script>
import DModal from '../common/DModal.vue'
import docendo from '../../docendo'
import Loader from '../common/Loader.vue'

export default {
  components: {Loader, DModal},
  props: {
    schoolId: {}
  },
  data () {
    return {
      isLoading: false,
      systems: [
        {value: 'KMD', name: 'KMD OPUS'},
        {value: 'SD', name: 'SD LØN'}
      ]
    }
  },
  methods: {
    select (system) {
      // this.isLoading = true
      const updates = {salary_system: system.value}
      docendo.updateSchool(this.schoolId, updates, success => {
        this.$store.commit('setActiveSchool', success)
      }, failure => {
        console.log({failure})
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-boxes {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.d-box-select {
  flex: 1;
  height: 150px;
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  border-radius: 4px;
  cursor: pointer;
}

.d-box-select:hover {
  background: aliceblue;
  border-color: var(--primary);
}

.d-modal--width {
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// ChooseSalarySystem.vue?1736fc68